import React from 'react'
import { useNavigate } from "react-router-dom";
import "../../NewSettings.scss";
import Grid from "@mui/material/Unstable_Grid2";
import { Box, Radio } from "@mui/material";
import LightModeIcon from '@mui/icons-material/LightMode';
import NightsStayIcon from '@mui/icons-material/NightsStay';
import CompareIcon from '@mui/icons-material/Compare';

function Appearance() {
  const navigate = useNavigate();

  const [selectedValue, setSelectedValue] = React.useState('a');
  const [darkThemeStatus, setDarkThemeStatus] = React.useState(false);
  const add_dark_theme = (status: boolean) => {
    if (status == true) {
      document.body.classList.add("theme-dark");
    } else {
      document.body.classList.remove("theme-dark");
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setSelectedValue(event.target.value);
  };

  return (
    <Box className="settingMenuWrapper">
      <Grid container spacing={3}>
            <Grid  xs={12}>
                <h3 className='mb-2'>Theme Preferences </h3>
                <p>Choose how it looks to you. Select a single theme, or automatically switch between day and night themes. </p>
            </Grid>
            <Grid  xs={6} md={4} lg={3}>
                <Box className='themeBox'>
                    <Grid container spacing={0} alignItems="center">
                        <Grid  xs={10}>
                            <h5><LightModeIcon /> Light Default</h5>
                        </Grid>
                        <Grid  xs={2}>
                            <Radio
                                checked={selectedValue === 'a'}
                                onChange={handleChange}
                                value="a"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'A' }}
                                onClick={() => {
                                    add_dark_theme(darkThemeStatus);
                                    setDarkThemeStatus(darkThemeStatus);
                                  }}
                            />
                        </Grid>
                    </Grid>
                    <hr />
                    <Grid container spacing={3}>
                        <Grid  xs={12} className="text-center">
                            <img src='./images/light_theme_img.svg' />
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid  xs={6} md={4} lg={3}>
                <Box className='themeBox darkTheme'>
                    <Grid container spacing={0} alignItems="center">
                        <Grid  xs={10}>
                            <h5><NightsStayIcon /> Dark Dimmed</h5>
                        </Grid>
                        <Grid  xs={2}>
                            <Radio
                                checked={selectedValue === 'b'}
                                onChange={handleChange}
                                value="b"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'B' }}
                                onClick={() => {
                                    add_dark_theme(!darkThemeStatus);
                                    // setDarkThemeStatus(!darkThemeStatus);
                                  }}
                            />
                        </Grid>
                    </Grid>
                    <hr />
                    <Grid container spacing={3}>
                        <Grid  xs={12} className="text-center">
                            <img src='./images/dark_theme_img.svg' />
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid  xs={6} md={4} lg={3}>
                <Box className='themeBox'>
                    <Grid container spacing={0} alignItems="center">
                        <Grid  xs={10}>
                            <h5><CompareIcon /> Auto Switch</h5>
                        </Grid>
                        <Grid  xs={2}>
                            <Radio
                                checked={selectedValue === 'c'}
                                onChange={handleChange}
                                value="c"
                                name="radio-buttons"
                                inputProps={{ 'aria-label': 'C' }}
                            />
                        </Grid>
                    </Grid>
                    <hr />
                    <Grid container spacing={3}>
                        <Grid  xs={12} className="text-center">
                            <img src='./images/auto_theme_img.svg' />
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    </Box>
  )
}

export default Appearance